export const GolfGulfCoords = [
  {
    start: {
      x: 0,
      y: 0,
    },
    hole: {
      x: 0,
      y: 0,
    },
  },
];
